export const NARRATIVE_ENGINE_MODES = [
  'ORIGINAL_ENGINE_COMPAT',
  'EXPERIMENTAL_CURRENT',
] as const;

export type NarrativeEngineMode = (typeof NARRATIVE_ENGINE_MODES)[number];

export function parseNarrativeEngineMode(
  raw: string | undefined,
): NarrativeEngineMode | null {
  if (raw === 'ORIGINAL_ENGINE_COMPAT' || raw === 'EXPERIMENTAL_CURRENT') {
    return raw;
  }
  return null;
}

export function resolveNarrativeEngineMode(
  raw: string | undefined,
  options?: { allowDefault?: boolean },
): NarrativeEngineMode {
  const parsed = parseNarrativeEngineMode(raw);
  if (parsed) return parsed;
  if (options?.allowDefault) {
    return 'EXPERIMENTAL_CURRENT';
  }
  throw new Error(
    `Invalid VITE_NARRATIVE_ENGINE_MODE: ${raw ?? '(missing)'}. ` +
      `Required: ORIGINAL_ENGINE_COMPAT | EXPERIMENTAL_CURRENT`,
  );
}

export function isOriginalEngineCompatMode(raw: string | undefined): boolean {
  return parseNarrativeEngineMode(raw) === 'ORIGINAL_ENGINE_COMPAT';
}
